import translations from '../../components/location/ts/lt-LT';
import { registerLocale } from '../../components/location/localeStrings';

registerLocale('lt-LT', translations);
